/**
 * Extracts named parameters from a file path using a template string.
 * @example
 *   extractVarsFromFilePath(
 *     'inProgressJobs_tinker/org_e9alyo5bnjy24lm9towy/schedule_summary/abc/file.avro',
 *     'inProgressJobs_tinker/${dataset}/${table}/**'
 *   )
 *   // Result = { dataset: 'org_e9alyo5bnjy24lm9towy', table: 'schedule_summary' }
 */
export function extractVarsFromFilePath(
  filePath: string,
  template: string
): Record<string, string> {
  // Escape regex special chars except for our ${var} and *
  // let regexStr = template.replace(/[-[\]/{}()+?.\\^$|]/g, '\\$&');
  // Replace ${var} with named capture groups
  let regexStr = template.replace(
    /\$\{(\w+)\}/g,
    (_, name) => `(?<${name}>[^/]+)`
  );

  // Replace ** with a placeholder to avoid conflict with *
  regexStr = regexStr.replace(/\*\*/g, '__DOUBLE_STAR__');
  // Replace * with [^/]* (matches anything except /)
  regexStr = regexStr.replace(/\*/g, '[^/]*');
  // Replace the placeholder with .*
  regexStr = regexStr.replace(/__DOUBLE_STAR__/g, '.*');

  const regex = new RegExp('^' + regexStr + '$');
  const match = filePath.match(regex);
  if (!match || !match.groups) {
    return {};
  }
  return match.groups;
}
